import * as React from "react";

import { FocusZone, FocusZoneDirection } from "azure-devops-ui/FocusZone";
import { NavigationItem } from "./NavigationItem";
import { IPageDefinition, IPageGroupDefinition } from "./PageDefinitionTypes";

import { pageGroups, pages } from "../_Generated/Pages";
import { makeFullUrl } from "../routing";

import "./Navigation.scss";

import { Route, RouteComponentProps } from "react-router-dom";

export interface INavigationProps {
    expandAll?: boolean;
    onNavigate?: () => void;
}

function isUrlMatch(fullUrl: string, location: Location, isRootPage: boolean): boolean {
    return location.pathname === fullUrl || location.pathname === fullUrl + "/" || (isRootPage && (location.pathname === "/" || !location.pathname));
}

class Navigation extends React.Component<INavigationProps> {
    public render() {
        return <Route children={this.renderNavList} />;
    }

    private renderNavList = (routeProps: RouteComponentProps) => {
        const onSelectedTabChanged = (newUrl: string) => {
            routeProps.history.push(newUrl);
            this.forceUpdate();

            if (this.props.onNavigate) {
                this.props.onNavigate();
            }
        };

        // Sort the pages alphabetically
        const componentPages = pages.sort((a: IPageDefinition, b: IPageDefinition) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0));

        // Create a map of group id to the group
        const groupDefinitionMap = pageGroups.reduce((map: { [key: string]: IPageGroupDefinition }, group: IPageGroupDefinition) => {
            map[group.id] = group;
            return map;
        }, {});

        // Pages map will be a map of page id to page
        const pagesMap: { [key: string]: IPageDefinition } = {};

        // Group map will be a map of group id to children
        const groupMapping: { [key: string]: IPageDefinition[] } = {};

        // Keep track of which group is selected
        let selectedGroup = "";
        for (const p of componentPages) {
            if (p.group) {
                let group = groupMapping[p.group];
                if (!group) {
                    group = [];
                    groupMapping[p.group] = group;
                }

                if (!selectedGroup && location.pathname === makeFullUrl(p.url)) {
                    selectedGroup = p.group;
                }

                // Add a page if it is not the overview page for a group
                if (!groupDefinitionMap[p.group] || groupDefinitionMap[p.group].page !== p.id) {
                    group.push(p);
                }
            }

            pagesMap[p.id] = p;
        }

        const pageGroupDefinitions = pageGroups.sort((a: IPageGroupDefinition, b: IPageGroupDefinition) => a.order - b.order);
        const groupComponents = [];
        let firstPageUrl: string | undefined;
        for (const g of pageGroupDefinitions) {
            const pagesForGroup = groupMapping[g.id] || [];

            // Lookup the url for group
            let url = "";
            if (g.page) {
                const page = pagesMap[g.page];
                if (page) {
                    url = makeFullUrl(page.url);
                } else {
                    continue;
                }
            } else if (pagesForGroup && pagesForGroup.length) {
                const firstPage = pagesForGroup[0];
                url = makeFullUrl(firstPage.url);
            } else {
                continue;
            }

            if (!firstPageUrl) {
                firstPageUrl = url;
            }

            groupComponents.push(
                <NavigationItem
                    key={"group-" + url}
                    id={"group-" + url}
                    name={g.name}
                    url={url}
                    children={pagesForGroup.map(p => {
                        const childPageUrl = makeFullUrl(p.url);
                        return (
                            <NavigationItem
                                key={"child-" + childPageUrl}
                                className={"child"}
                                id={"child-" + childPageUrl}
                                name={p.name}
                                url={childPageUrl}
                                isSelected={isUrlMatch(childPageUrl, location, p.id === "home")}
                                isExpanded={false}
                                onClick={onSelectedTabChanged}
                            />
                        );
                    })}
                    isSelected={isUrlMatch(url, location, g.id === "overview")}
                    isExpanded={selectedGroup === g.id || !!this.props.expandAll}
                    onClick={onSelectedTabChanged}
                />
            );
        }

        return (
            <FocusZone
                direction={FocusZoneDirection.Vertical}
                circularNavigation={true}
                focusGroupProps={{ defaultElementId: "group-" + firstPageUrl }}
            >
                <nav key={1}><ul>{groupComponents}</ul></nav>
            </FocusZone>
        );
    };
}

export default Navigation;
